import React, { useEffect, useState, useRef, useCallback } from "react";
import { motion, useAnimation, useInView } from "framer-motion";
import axios from "axios";

const SpiritofCelebration = () => {
  const ref = useRef(null);
  const isInView = useInView(ref, { once: true });
  const controls = useAnimation();

  const [images, setImages] = useState([]);
  const [currentIndex, setCurrentIndex] = useState(0);

  // State for touch events
  const [touchStartX, setTouchStartX] = useState(0);
  const [touchEndX, setTouchEndX] = useState(0);

  useEffect(() => {
    if (isInView) controls.start("visible");
  }, [isInView, controls]);

  useEffect(() => {
    axios
      .get("https://ethiccraft.org/backend/excellence/read_isShown.php")
      .then((response) => {
        const filtered = response.data;
        setImages(filtered);
      })
      .catch((error) => console.error("Error fetching images:", error));
  }, []);

  const visibleImages = images.slice(currentIndex, currentIndex + 3);

  const handlePrev = useCallback(() => {
    setCurrentIndex((prevIndex) => Math.max(0, prevIndex - 1));
  }, []);

  const handleNext = useCallback(() => {
    setCurrentIndex((prevIndex) => Math.min(images.length - 3, prevIndex + 1));
  }, [images.length]); // Depend on images.length

  // Touch handlers
  const handleTouchStart = (e) => {
    setTouchStartX(e.touches[0].clientX);
  };

  const handleTouchMove = (e) => {
    setTouchEndX(e.touches[0].clientX);
  };

  const handleTouchEnd = () => {
    if (touchStartX === 0 && touchEndX === 0) return; // No touch movement

    const minSwipeDistance = 50; // Minimum distance for a swipe to be registered
    const distance = touchStartX - touchEndX;

    if (distance > minSwipeDistance) {
      // Swiped left (show next)
      handleNext();
    } else if (distance < -minSwipeDistance) {
      // Swiped right (show previous)
      handlePrev();
    }

    // Reset touch state
    setTouchStartX(0);
    setTouchEndX(0);
  };

  const titleVariants = {
    hidden: { opacity: 0, y: -50 },
    visible: { opacity: 1, y: 0, transition: { duration: 1, ease: "easeOut" } },
  };

  const imageVariants = {
    hidden: { opacity: 0, scale: 0.9 },
    visible: {
      opacity: 1,
      scale: 1,
      transition: { duration: 0.8, ease: "easeOut" },
    },
  };

  return (
    <div className="spirit_of_celebration" ref={ref}>
      {/* <motion.p className="small-title" initial="hidden" animate={controls} variants={titleVariants}>
        Ethiccraft Presents
      </motion.p> */}

      <motion.h1
        className="celebration_main-title"
        initial="hidden"
        animate={controls}
        variants={titleVariants}
      >
        <span className="highlight">Spotlight on Excellence</span>
        {/* <br /> */}
        {/* <span className="outline"></span> */}
      </motion.h1>

      <div className="carousel-wrapper">
        <div
          className="images"
          onTouchStart={handleTouchStart}
          onTouchMove={handleTouchMove}
          onTouchEnd={handleTouchEnd}
        >
          {visibleImages.map((img, index) => (
            <motion.div
              key={img.id}
              className={`image ${index === 0 ? "image-left" : index === 2 ? "image-right" : "image-center"}`}
              whileHover={{ scale: 1.05 }}
              initial="hidden"
              animate="visible"
              variants={imageVariants}
            >
              <img
                src={`https://ethiccraft.org/${img.image}`}
                alt={`gallery-${img.id}`}
              />
              {index === 2 && <div className="tape"></div>}
            </motion.div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default SpiritofCelebration;
